module.exports = __webpack_public_path__ + "static/media/whoop-large.14a3c631.png";